<template>
  <div class="myPOS">
    <div id="myPOSEmbeddedCheckout"></div>
  </div>
</template>

<script>
// import * as MyPOSEmbedded from "mypos-embedded-checkout";

import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      order: "orders/order",
    }),
  },
  methods: {
    ...mapMutations({
      setState: "main/setState",
    }),
    ...mapActions({
      makePaid: "orders/makePaid",
    }),
    retryPayment() {
      this.destroyWidget();
      this.initWidget();
    },
    destroyWidget() {
      document.getElementById("myPOSEmbeddedCheckout").innerHTML = "";
    },
    initWidget() {
      const vm = this;

      const paymentParams = {
        sid: "295002",
        walletNumber: "40329595215",
        ipcLanguage: "en",
        amount: this.order.total_price,
        currency: "EUR",
        orderID: this.order.id,
        urlNotify: "https://api.dev.getprofy.de/client/ipcNotify",
        keyIndex: 2,
        cartItems: [
          {
            article: "Zahlung für Dienstleistungen",
            quantity: 1,
            price: this.order.total_price,
            currency: "EUR",
          },
        ],
      };

      const callbackParams = {
        isSandbox: false,
        onMessageReceived: function(messages) {
          //Error and info messages.
          console.log(messages);
        },
        onSuccess: function(data) {
          setTimeout(async () => {
            await vm.makePaid(vm.order.id);
            vm.$emit("fetch");
            vm.setState({
              key: "mainModal",
              value: false,
            });
          }, 500);

          console.log("success callback");
          console.log(data);
        },
        onError: function(error) {
          console.log("error", error);
          //   alert("An error occured");
        },
      };

      MyPOSEmbedded.createPayment(
        "myPOSEmbeddedCheckout",
        paymentParams,
        callbackParams
      ).then(() => {
       const el =  document.getElementById('myposCheckoutLoadingComponent')
       console.log(el)
      }).catch((err) => console.log(err));
    },
  },
  mounted() {
    this.initWidget();
  },
};
</script>

<style lang="scss">
.myPOS-box {
  background-color: #fff;
  padding: 20px;

  &__retry-button {
    height: 30px !important;
    width: 80px !important;
    background-color: grey !important;
    box-shadow: unset !important;
  }
}
</style>
